/* eslint-disable eqeqeq */
import { useHistory, useLocation } from 'react-router';
import { useMemo } from 'react';

type FType<T> = <U extends keyof T>(field: U, value: T[U]) => void;

interface UseQueryParamsStateReturnValue<T> {
    queryParams: T;
    setQueryParam: FType<T>;
    setQueryParams: (values: { [key: string]: any }) => void;
}

const booleanValueMap: { [key: string]: boolean } = {
    true: true,
    True: true,
    false: false,
    False: false
};

export function useQueryParamsState<T extends {}>(defaults?: Partial<T>): UseQueryParamsStateReturnValue<T> {
    const location = useLocation();
    const history = useHistory();

    const searchParams = useMemo(() => {
        const params = new URLSearchParams(location.search);
        let paramsDictionary: any = {
            ...defaults
        };

        params.forEach((value, key) => {
            //@ts-ignore
            if (parseInt(value, 10) == value) {
                paramsDictionary[key] = parseInt(value, 10);
            } else if (booleanValueMap.hasOwnProperty(value)) {
                paramsDictionary[key] = booleanValueMap[value];
            } else {
                paramsDictionary[key] = value;
            }
        });

        return paramsDictionary;
    }, [location.search]);

    const setQueryParam: FType<T> = (field, value: any) => {
        const qp = new URLSearchParams(location.search);
        qp.set(`${field.toString()}`, `${value}`);
        history.push(`?${qp.toString()}`);
    };

    const setQueryParams: any = (values: { [key: string]: any }) => {
        const qp = new URLSearchParams(location.search);

        for (const valuesKey in values) {
            qp.set(`${valuesKey}`, `${values[valuesKey]}`);
        }

        history.replace(`?${qp.toString()}`);
    };

    return {
        queryParams: searchParams as T,
        setQueryParams,
        setQueryParam
    };
}
